import { Button } from "@material-ui/core";
import { InputLabel } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import MainContainer from "../components/containers/MainContainer";
import { useDispatch, useSelector } from "react-redux";
import { setLoadingPage } from "../redux/items/PageLoading";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import { useHistory } from "react-router-dom";
import FetchLogin from "../components/Fetch/FetchLogin";
import PhoneInput from "react-phone-number-input";
import { Else, If, Then } from "react-if";

const Refer = () => {
	const [v, setV] = useState({
		referList: [],
		dates: [],
		selectedDate: "",
		error: "",

		contact_no: "",
		sendError: "",
		sendColor: "green",
		isShareBtn: false,
		link: "",
	});
	const token = useSelector((state) => state.login.token);
	const dispatch = useDispatch();
	const hist = useHistory();

	const bottomRef = useRef(null);

	const setV2 = (v2) => {
		setV((prev) => ({ ...prev, ...v2 }));
	};

	const reqReferList = FetchLogin("refer-list", {
		data: {
			token: token,
			date: v.selectedDate,
		},
		callbackInit: () => {
			setV2({ referList: [], error: "", dates: [] });
			dispatch(setLoadingPage(true));
		},
		callback: (cb) => {
			if (cb.response.success) {
				setV2({
					referList: cb.response.data.referList,
					dates: cb.response.data.dates,
				});
				bottomRef.current?.scrollIntoView({ behavior: "smooth" });
			} else setV2({ error: cb.response.message });
			dispatch(setLoadingPage(false));
		},
	});

	const reqSendRefer = FetchLogin("refer-send", {
		data: {
			token: token,
			contactNo: v.contact_no,
			web: window.location.hostname,
		},
		callbackInit: () => {
			setV2({
				sendError: "",
				sendColor: "green",
				isShareBtn: false,
				link: "",
			});
			dispatch(setLoadingPage(true));
		},
		callback: (cb) => {
			if (cb.response.success) {
				setV2({
					contact_no: "",
					sendError: cb.response.message,
					isShareBtn: true,
					link: cb.response.data.url,
				});
				reqReferList.handleTrigger();
			} else setV2({ sendError: cb.response.message, sendColor: "red" });

			setTimeout(() => {
				dispatch(setLoadingPage(false));
			}, 0);
		},
	});

	const shareBtnTrigger = async () => {
		if (navigator.share) {
			try {
				await navigator.share({
					title: "Fatcat Singapore 4D & TOTO",
					text: "Share our link, refer your friends and get rewarded!",
					url: v.link,
				});
				console.log("Thanks for sharing!");
			} catch (err) {
				console.error("Error sharing:", err);
			}
		} else {
			alert("Sharing not supported in this browser.");
		}
	};

	useEffect(() => {
		reqReferList.handleTrigger();
		// eslint-disable-next-line
	}, [, v.selectedDate]);

	return (
		<>
			<MainContainer>
				<div style={{ marginTop: 100 }}>
					<div style={{ textAlign: "center" }}>
						<h1>Why refer a friend?</h1>
						<p>
							When your friend place a bet on 4D lottery slip in the website and
							win. You will receive 5% of the prize money! While your friend
							receive the full actual prize money!{" "}
							<span style={{ color: "#bbb" }}>
								Ex. Your friend win SGD 10,000, You will get SGD 500
							</span>
						</p>
						<h1>More on How It Works</h1>

						<ol style={{ textAlign: "left" }}>
							{/* <li>Type in your mobile number</li>
              <li>You will receive a one-time OTP</li> */}
							<li>Type in your friend's mobile number.</li>
							<li>Your friend will receive a SMS with a link.</li>
							<li>
								Once your friend click on the link. It's done! Is that simple.
							</li>
						</ol>
					</div>
					<If condition={!v.isShareBtn}>
						<Then>
							4D Draw Date:{" "}
							<select
								value={v.selectedDate}
								onChange={(e) => {
									setV2({ selectedDate: e.target.value });
									//   console.log(e.target.value);
								}}
							>
								<option></option>
								{v.dates.map((e, i) => (
									<option key={i}>{e}</option>
								))}
							</select>
							{v.referList.length === 0 ? (
								<p
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: 100,
										fontSize: 18,
									}}
								>
									No one Booked on your Referal
								</p>
							) : (
								<>
									<div
										style={{
											display: "flex",
											flexDirection: "row",
											justifyContent: "flex-start",
											alignItems: "center",
											fontSize: 20,
											borderBottom: "1px solid #ddd",
										}}
									>
										<span
											style={{
												// backgroundColor: "red",
												height: 64,
												width: "10%",
												textAlign: "center",
												lineHeight: 3,
											}}
										>
											#
										</span>
										<span
											style={{
												// backgroundColor: "red",
												height: 64,
												width: "50%",
												paddingLeft: 24,
												paddingRight: 24,
												lineHeight: 3,
											}}
										>
											Name/Contact
										</span>
										<span
											style={{
												// backgroundColor: "red",
												height: 64,
												width: "20%",
												paddingLeft: 24,
												paddingRight: 24,
												lineHeight: 3,
											}}
										>
											Referred
										</span>
										<span
											style={{
												// backgroundColor: "red",
												height: 64,
												width: "20%",
												lineHeight: 3,
											}}
										>
											Booked
										</span>
									</div>
									{v.referList.map((e, i) => {
										return (
											<div
												key={i}
												style={{
													display: "flex",
													flexDirection: "row",
													justifyContent: "flex-start",
													alignItems: "center",
													fontSize: 20,
													borderBottom: "1px solid #ddd",
												}}
											>
												<span
													style={{
														// backgroundColor: "red",
														height: 64,
														width: "10%",
														textAlign: "center",
														lineHeight: 3,
													}}
												>
													{i + 1}
												</span>
												<span
													style={{
														// backgroundColor: "red",
														height: 64,
														width: "50%",
														paddingLeft: 24,
														paddingRight: 24,
													}}
												>
													{e.name === "" ? <i>No Name</i> : e.name}
													<br />
													{e.contact_no}
												</span>
												<span
													style={{
														// backgroundColor: "red",
														height: 64,
														width: "20%",
														paddingLeft: 24,
														paddingRight: 24,
														lineHeight: 4,
													}}
												>
													{e.confirm_click_refer === 0 ? (
														<CancelIcon
															style={{
																fontSize: 30,
																color: "red",
															}}
														/>
													) : (
														<CheckCircleIcon
															style={{
																fontSize: 30,
																color: "green",
															}}
														/>
													)}
												</span>
												<span
													style={{
														// backgroundColor: "red",
														height: 64,
														width: "20%",
														lineHeight: 3,
													}}
												>
													{e.no_of_bet}
												</span>
											</div>
										);
									})}
								</>
							)}
							<p
								dangerouslySetInnerHTML={{
									__html: v.error,
								}}
								style={{
									color: "red",
									textAlign: "center",
								}}
							/>
						</Then>
					</If>
					<div ref={bottomRef} />
					<If condition={!v.isShareBtn}>
						<Then>
							<InputLabel>Your Friends mobile number</InputLabel>
							<PhoneInput
								defaultCountry="SG"
								placeholder="98765432"
								onChange={(e) => {
									setV2({ contact_no: e });
								}}
								value={v.contact_no}
								style={{ marginTop: 10, marginBottom: 10 }}
							/>
						</Then>
					</If>
					<If condition={!v.isShareBtn}>
						<Then>
							<p
								dangerouslySetInnerHTML={{
									__html: v.sendError,
								}}
								style={{
									color: v.sendColor,
									textAlign: "center",
									fontSize: 20,
								}}
							/>
						</Then>
						<Else>
							<div
								style={{
									display: "flex",
									gap: "10px",
									justifyContent: "center",
									marginTop: "20px",
								}}
							>
								<Button
									variant="outlined"
									color="primary"
									onClick={() => {
										setV2({ isShareBtn: false, sendError: "" });
									}}
									style={{
										borderRadius: "8px",
										textTransform: "none",
										padding: "10px 20px",
									}}
								>
									Share More
								</Button>
								<Button
									variant="contained"
									color="primary"
									onClick={shareBtnTrigger}
									style={{
										borderRadius: "8px",
										textTransform: "none",
										padding: "10px 20px",
										boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
									}}
								>
									Share The Referal Link
								</Button>
							</div>
						</Else>
					</If>
					<If condition={!v.isShareBtn}>
						<Then>
							<Button
								onClick={() => {
									reqSendRefer.handleTrigger();
								}}
							>
								Submit
							</Button>
						</Then>
					</If>
					<br />
					<br />
					<div style={{ textAlign: "center" }}>
						<Button
							onClick={() => {
								hist.push("/");
							}}
							style={{
								marginBottom: 40,
							}}
						>
							Back to Home
						</Button>
					</div>
				</div>
			</MainContainer>
		</>
	);
};

export default Refer;
